import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { bookingReservationStatusOptions } from '@new/domains/bookingsTapeChart/BookingsTapeChart.constants'

import { FiltersSharedProps } from './Filters.types'

interface ReservationStatusFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _ReservationStatus: FC<ReservationStatusFilterProps> = props => {
  return (
    <CheckboxBasedFilter
      title="Reservation Status"
      options={bookingReservationStatusOptions}
      {...props}
    />
  )
}

export const ReservationStatus = observer(_ReservationStatus)
